import { AppstoreAddOutlined, DeleteOutlined, DownOutlined, EditOutlined } from '@ant-design/icons';
import { Button, Dropdown, Menu, Space } from 'antd';
import { useTranslation } from 'react-i18next';
import { type AudiCalculationModuleSpecsFragment } from '../../../../api/fragments/AudiCalculationModuleSpecs';
import { type PermissionValues } from '../../../../utilities/hasPermissions';
import useDeleteModule from '../useDeleteModule';
import { useAudiCalculationModuleUpdateDrawer } from './AudiCalculationModuleUpdateDrawer';

export type AudiCalculationModuleActionsProps = {
    module: AudiCalculationModuleSpecsFragment;
    openAudiCalculationSettingDrawer: () => void;
    permissions: Pick<PermissionValues, 'hasDeletePermission' | 'hasUpdatePermission'>;
};

const AudiCalculationModuleActions = ({
    module,
    openAudiCalculationSettingDrawer,
    permissions,
}: AudiCalculationModuleActionsProps) => {
    const { t } = useTranslation(['audiCalculationModuleDetails']);
    const deleteModule = useDeleteModule(module.id);

    const updateAudiCalculationModuleDrawer = useAudiCalculationModuleUpdateDrawer(module.id, {
        displayName: module.displayName,
    });

    const { hasUpdatePermission, hasDeletePermission } = permissions;

    const items = [
        hasUpdatePermission && {
            label: t('audiCalculationModuleDetails:mainActionButtons.updateSpecs'),
            key: 'updateSpecs',
            icon: <EditOutlined />,
            onClick: updateAudiCalculationModuleDrawer.open,
        },

        hasUpdatePermission && {
            label: t('audiCalculationModuleDetails:mainActionButtons.addSetting'),
            key: 'addSetting',
            icon: <AppstoreAddOutlined />,
            onClick: openAudiCalculationSettingDrawer,
        },

        hasDeletePermission && {
            label: t('audiCalculationModuleDetails:mainActionButtons.delete'),
            key: 'delete',
            icon: <DeleteOutlined />,
            onClick: deleteModule,
            danger: true,
        },
    ].filter(Boolean);

    if (!items.length) {
        return null;
    }

    return (
        <>
            <Dropdown overlay={<Menu items={items} />}>
                <Button type="primary">
                    <Space>
                        <span>{t('audiCalculationModuleDetails:mainActionButtons.actions')}</span>
                        <DownOutlined />
                    </Space>
                </Button>
            </Dropdown>
            {updateAudiCalculationModuleDrawer.render()}
        </>
    );
};

export default AudiCalculationModuleActions;
